import React from 'react';

import { ReportBugsContext } from '@qality/common-components/src/lib/ReportBugsProvider';

import { SearchBugView } from './SearchBug.view';

export const SearchBug = ({ onCreateIssueCallback }: any) => {
  const {
    createIssue,
    setSearchValue,
    searchResults,
    searchValue,
    addIssue,
    isLoadingSearchOptions,
  } = React.useContext(ReportBugsContext);

  const handleCreate = async () => {
    onCreateIssueCallback && onCreateIssueCallback();
    createIssue();
  };

  const handleAdd = async (issueId) => {
    addIssue(issueId);
  };

  const handleChangeSearchValue = async (text: string) => {
    setSearchValue(text);
  };

  return (
    <SearchBugView
      searchValue={searchValue}
      onChangeText={handleChangeSearchValue}
      onClickIssue={handleAdd}
      onCreateIssue={handleCreate}
      issuesList={searchResults}
      isLoadingSearchOptions={isLoadingSearchOptions}
    />
  );
};
